<div
        [ngClass]="{'loader-block-secondary': secondaryColor}"
        class="loader-block"
>
  <svg id="loader" viewBox="0 0 100 100">
    <circle id="circle-loader" cx="50" cy="50" r="45"></circle>
  </svg>
</div>
